module.exports = __webpack_public_path__ + "static/media/pin-image-img.fa452877.svg";